import axios from 'axios'

import { CalculationServiceWasteManagementApi } from '../../../publish/calculation/apis/calculation-service-waste-management-api'
import { Configuration } from '../../../publish/calculation/configuration'
import { setupAxiosInterceptors } from '../../axios-interceptor-utils'

export class CalculationServiceWasteManagement extends CalculationServiceWasteManagementApi {
  constructor(
    protected basePath: string,
    private getTokenFn?: () => Promise<string>,
  ) {
    super(new Configuration({ basePath: basePath }), basePath, axios.create())
    setupAxiosInterceptors(this.axios, this.getTokenFn)
  }
}
